import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_PATIENTS, ROUTE_UPLOAD_PATIENTS} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const Patients = lazy(() =>
  import('../../../screens/Patients')
    .then(module => ({default: module.Patients})));

const UploadPatients = lazy(() =>
  import('../../../screens/Patients/UploadPatients')
    .then(module => ({default: module.UploadPatients})));

const PatientNavigation = [
  {
    path: ROUTE_PATIENTS,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <Patients />
      </Suspense>
    ),
  },
  {
    path: ROUTE_UPLOAD_PATIENTS,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <UploadPatients />
      </Suspense>
    ),
  },
];

export default PatientNavigation;
